// extracted by mini-css-extract-plugin
export default {"clearBtn":"dataTableFilter_clearBtn__BI36B"};